<template>
  <section :class="['section', { 'section--grey' : elevated }, { 'section--alt-layout' : altLayout }]">
    <div class="container">
      <header class="section-header">
        <h2 v-if="title">{{ title }}</h2>
        <p v-if="description">{{ description }}</p>
      </header>
      <div class="section-content">
        <slot></slot>
      </div>
      <div v-if="footnote" class="footnote" v-html="footnote"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'vSection',
  props: {
    elevated: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    footnote: {
      type: String,
    },
    altLayout: {
      type: Boolean,
    },
  },
};
</script>
